export const callWhatsApp = (isMobile, phone) => {

  const UrlWA = `https://wa.me/+553121179072`;
  const url = `https://web.whatsapp.com/send?phone=+553121179072`;

  isMobile ? window.open(UrlWA) : window.open(url);

}
